import { Bar, mixins } from "vue-chartjs"
import numeral from "numeral"

export default Bar.extend({
    mixins: [mixins.reactiveProp],
    mounted () {
        this.renderChart(this.chartData, this.options)
    },
    watch: {
        // 'yMax': "reset"
        field: "reset"
    },
    methods: {
        reset () {
            if(this._chart) this._chart.destroy()
            this.renderChart(this.chartData, this.options)
        }
    },
    computed: {
        options () {
            return {
                tooltips: {
                    mode: "index",
                    callbacks: {
                        label: (tooltipItem, data) => {
                            if(this.field === "fee") return `${data.datasets[tooltipItem.datasetIndex].label}: $ ${numeral(tooltipItem.value).format("0,0")}`
                            return `${data.datasets[tooltipItem.datasetIndex].label}: ${numeral(tooltipItem.value).format("0,0")}`
                        },
                        footer: (tooltipItem, data) => {
                            if(this.field === "fee") return `Total: $ ${numeral(data.raw_data[tooltipItem[0].index]).format("0,0")}`
                            return `Projects: ${numeral(data.raw_data[tooltipItem[0].index]).format("0,0")}`
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                        stack: "main",
                        ticks: {
                            beginAtZero: true,
                            // suggestedMax: this.yMax,
                            fontColor: "#00274F",
                            callback: (value, index, values) => {
                                const value_numeral = numeral(value)
                                values = value_numeral.value()
                                if(this.field === "fee") {
                                    if(value >= 100000) return `$ ${numeral(value / 1000000).format("0,0.0")}M`
                                    if(value >= 1000) return `$ ${numeral(value / 1000).format("0,0.0")}K`
                                    return `$ ${value_numeral.format("0,0")}`
                                }
                                return `${value_numeral.format("0,0")}`
                            }
                        },
                        gridLines: {
                            display: true,
                            color: "rgba(0, 39, 79, 0.1)"
                        }
                    }],
                    xAxes: [{
                        stacked: true,
                        stack: "main",
                        ticks: {
                            fontSize: 10,
                            fontColor: "#00274F"
                        },
                        gridLines: {
                            display: false,
                            color: "rgba(0, 39, 79, 0.1)"
                        },
                        categoryPercentage: 0.9,
                        barPercentage: 0.8
                    }]
                },
                legend: {
                    display: true,
                    position: "bottom",
                    labels: {
                        fontSize: 11,
                        // fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                        fontStyle: "bold",
                        fontColor: "#00274F",
                        boxWidth: 14,
                        padding: 13
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    props: {
        chartData: {
            type: Array | Object,
            required: false
        },
        field: {
            type: String,
            required: true
        }/*,
        yMax: {
            type: Number,
            default: 0
        } */
    }
})
